const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");
